
export const calculateSalesTaxAmount = (subtotal, taxRate) => {
  if (!subtotal || isNaN(subtotal) || subtotal <= 0) {
    return 0;
  }
  
  if (!taxRate || isNaN(taxRate) || taxRate < 0) {
    return 0;
  }
  
  return parseFloat((subtotal * taxRate).toFixed(2));
};

export const calculateTotalWithTax = (subtotal, taxRate) => {
  const taxAmount = calculateSalesTaxAmount(subtotal, taxRate);
  return parseFloat((subtotal + taxAmount).toFixed(2));
};

export const convertTaxRateToDecimal = (taxRatePercentage) => {
  if (!taxRatePercentage || isNaN(taxRatePercentage)) {
    return 0;
  }
  return parseFloat((taxRatePercentage / 100).toFixed(4));
};

export const formatTaxRate = (taxRate) => {
  if (!taxRate || isNaN(taxRate)) {
    return '0%';
  }
  return `${(taxRate * 100).toFixed(2)}%`;
};

export const calculateInvoiceTax = (designAmount, taxRate) => {
  const subtotal = parseFloat(designAmount);
  const taxAmount = calculateSalesTaxAmount(subtotal, taxRate);
  const total = calculateTotalWithTax(subtotal, taxRate);
  
  return {
    subtotal: parseFloat(subtotal.toFixed(2)),
    taxAmount: parseFloat(taxAmount.toFixed(2)),
    total: parseFloat(total.toFixed(2)),
    taxRate: taxRate
  };
};
